var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",null,null,{copyPublishedUrl: _vm.copyPublishedUrl})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }